import React from "react";
import {Stepper} from "@stepperize/react";
import { Accordion } from "radix-ui";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faChevronRight} from "@fortawesome/pro-solid-svg-icons";
import {faFilePdf} from "@fortawesome/pro-regular-svg-icons";
import {CreateProjectStep} from "../stepper/create-project-steps.ts";
import useProjectCreationContext from "../context/use-project-creation-context.ts";
import Button from "@/components/buttons/button";
import Tooltip from "@/components/tooltip";

interface ProjectInformationsStepProps {
    stepper: Stepper<CreateProjectStep[]>
}

const CreateProjectOrganisationDetailsStep: React.FC<ProjectInformationsStepProps> = ({stepper}) => {
    const { data, createProject } = useProjectCreationContext();
    const { prev, next } = stepper;

    return (
        <div className='flex flex-col flex-1 h-full min-h-0 justify-between overflow-hidden'>
            <Tooltip id='building-details'/>
            <Accordion.Root type="multiple" defaultValue={data.buildings.map(b => b.name)}
                            className='min-h-0 h-full overflow-auto flex flex-col gap-y-2.5 '>
                {data.buildings.map((building) => (
                    <Accordion.Item key={building.name} value={building.name}>
                        <Accordion.Header className='bg-gray-50 rounded px-2'>
                            <Accordion.Trigger className='group w-full'>
                                <div className='flex flex-row items-center gap-x-4'>
                                        <FontAwesomeIcon icon={faChevronRight}
                                                         className='transition-transform duration-300 ease-in-out group-data-[state=open]:rotate-90 text-xs mb-px'/>

                                    <span className='font-semibold uppercase'>{building.name}</span>
                                </div>
                            </Accordion.Trigger>
                        </Accordion.Header>
                        <Accordion.Content className='data-[state=open]:animate-slideDown data-[state=closed]:animate-slideUp overflow-hidden'>
                            <div className='flex flex-col gap-y-2 ms-10 border-s mt-2 mr-8'>
                                {building.storeys.map(s => (
                                    <div className={`flex flex-col ${s?.altimetry === 0 ? 'border-b pb-2' : ''}`} key={building.name + s.name}>
                                        <div className='grid grid-cols-[1fr_auto_auto_auto] gap-x-4 items-center ps-4'>
                                            <span>{s.name}</span>
                                            <span>{s.altimetry} m</span>
                                            <span>{s.storeyType}</span>
                                            <FontAwesomeIcon icon={faFilePdf} className='text-orange-700'
                                                             data-tooltip-id='building-details' data-tooltip-content={s.file?.name}/>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </Accordion.Content>
                    </Accordion.Item>
                ))}
            </Accordion.Root>

            <div className="mt-2 flex shrink-0 justify-between">
                <Button onClick={() => prev()}>Revenir en arrière</Button>
                <Button onClick={() => {
                    createProject();
                    next();
                }}>
                    Créer le projet
                </Button>
            </div>
        </div>
        
    )
}

export default CreateProjectOrganisationDetailsStep;